import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'animate.css'; // Import animate.css for WOW.js

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);